import React, { ReactNode, useEffect } from "react";
import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { usersThunkActions } from "../../redux/actions/users";
import { IAppState } from "../../redux/reducers";

const mapStateToProps = (state: IAppState) => {
    return {
        user: state.users.currentUser,
        expired: state.users.sessionExpired,
    };
};

const mapDispatchToProps = (
    dispatch: ThunkDispatch<IAppState, void, Action>
) => {
    return {
        getCurrentUser: () => dispatch(usersThunkActions.getCurrentUser()),
    };
};

interface IRequireAuthProps
    extends ReturnType<typeof mapStateToProps>,
        ReturnType<typeof mapDispatchToProps> {
    children: ReactNode;
    redirectTo: string;
}


export const RequireAuth = connect(mapStateToProps, mapDispatchToProps)((props: IRequireAuthProps) => {

    useEffect(() => {
        if (!props.user) {
            props.getCurrentUser();
        }

        // eslint-disable-next-line
    }, []);

    let isAuthenticated = !!props.user && !props.expired;
    let location = useLocation();

    return isAuthenticated
        ? props.children
        : <Navigate to={props.redirectTo} state={{ from: location }} />;
});
